/**
 * Feedback — one tabbed screen over the whole loop, built on the shared
 * GroupScreen used by Notifications, Logs and Background Jobs.
 *
 *   Feedback Master  what to ask, about what        (CRUD)
 *   Submissions      what users actually said       (read-only; close / reopen)
 *   Reviews          the SME queue and the verdicts (complete a row, never create)
 *
 * The three tabs are three different permissions, not three views of one: an end
 * user can submit without being able to read anyone else's, and an SME can review
 * without being able to edit the definition. GroupScreen hides a tab the user has
 * no permission for, so each person sees only their part of the loop.
 *
 * Create / edit of a definition still navigate to the existing form pages at
 * /feedback-master/*; nothing about those screens changed.
 *
 * Everything here is scoped CORE — screens, APIs, functions. Feedback on a model's
 * output has its own screen under AI, because the people who answer for a wrong
 * answer are not the people who answer for a broken screen, and a single queue
 * mixing the two is a queue where each of them scrolls past the other's work.
 * The collections underneath are the same two, and so is the review process.
 */
import GroupScreen from '../../components/layout/group-screen';
import { JOB_NAMES } from '../../constants/jobNames';
import FeedbackMasterList from '../feedback-master/feedback-master-list';
import MyFeedbackTab from './tabs/my-feedback-tab';
import SubmissionsTab from './tabs/submissions-tab';
import ReviewsTab from './tabs/reviews-tab';

const FeedbackGroup = () => (
  <GroupScreen
    icon="message-dots"
    iconBgColor="bg-indigo-600"
    title="Feedback"
    subtitle="What to ask, what came back, and what was done about it"
    testId="SCR-Feedback"
    tabs={[
      {
        key: 'definitions', header: 'Feedback Master', leftIcon: 'message-dots',
        jobs: [JOB_NAMES.FEEDBACK_MASTER], element: <FeedbackMasterList scope="CORE" />,
      },
      {
        // One person's own two lists — what I said, and what is waiting on me.
        // Needs only FEEDBACK_SUBMISSION.READ, so an SME sees their own queue
        // without being able to read everyone else's.
        key: 'mine', header: 'My Feedback', leftIcon: 'user-square',
        jobs: [JOB_NAMES.FEEDBACK_SUBMISSION], element: <MyFeedbackTab />,
      },
      {
        key: 'submissions', header: 'Feedback Submission', leftIcon: 'message-text',
        jobs: [JOB_NAMES.FEEDBACK_SUBMISSION], element: <SubmissionsTab scope="CORE" />,
      },
      {
        key: 'reviews', header: 'Feedback Review', leftIcon: 'message-check',
        jobs: [JOB_NAMES.FEEDBACK_REVIEW], element: <ReviewsTab scope="CORE" />,
      },
    ]}
  />
);

export default FeedbackGroup;
